export default function PHP_localeconv() {
  return (
    <div>
      <h1>PHP_localeconv</h1>
    </div>
  );
}
